(() => {
  if (customElements.get('product-offer-gifts')) return;

  class ProductOfferGifts extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('product-info') || this.closest('.product') || document;
      this.handleQuantityChange = this.handleQuantityChange.bind(this);

      this.scope.addEventListener('change', this.handleQuantityChange);
      this.scope.addEventListener('input', this.handleQuantityChange);
      this.syncState();
      this.initialSyncFrame = requestAnimationFrame(() => this.syncState());
    }

    disconnectedCallback() {
      this.scope?.removeEventListener('change', this.handleQuantityChange);
      this.scope?.removeEventListener('input', this.handleQuantityChange);
      if (this.initialSyncFrame) cancelAnimationFrame(this.initialSyncFrame);
    }

    handleQuantityChange(event) {
      if (
        !event.target.matches(
          '.lumin-product-block-qty-break input[type="radio"], input[name="quantity"]'
        )
      ) {
        return;
      }

      this.syncState();
    }

    selectedQuantity() {
      const selectedTierInput = this.scope.querySelector(
        '.lumin-product-block-qty-break input[type="radio"]:checked'
      );
      const selectedTier = selectedTierInput?.closest('lumin-product-qty-break');
      const tierQuantity = Number(selectedTier?.dataset.qty);

      if (Number.isFinite(tierQuantity) && tierQuantity > 0) return tierQuantity;

      const quantityInput = this.scope.querySelector('input[name="quantity"]');
      const fallbackQuantity = Number(quantityInput?.value);

      return Number.isFinite(fallbackQuantity) && fallbackQuantity > 0 ? fallbackQuantity : 1;
    }

    syncState() {
      const requiredQuantity = Number(this.dataset.requiredQuantity) || 1;
      const selectedQuantity = this.selectedQuantity();
      const isUnlocked = selectedQuantity >= requiredQuantity;
      const state = isUnlocked ? 'unlocked' : 'locked';
      const labelTemplate = isUnlocked ? this.dataset.unlockedLabel : this.dataset.lockedLabel;
      const label = (labelTemplate || '').replaceAll('[qty]', String(requiredQuantity));

      this.dataset.offerState = state;
      this.dataset.selectedQuantity = String(selectedQuantity);

      const status = this.querySelector('[data-offer-status]');
      if (status) status.textContent = label;

        this.querySelectorAll('[data-offer-item]').forEach((item) => {
        const itemRequiredQuantity = Number(item.dataset.requiredQuantity) || requiredQuantity;
        const itemIsUnlocked = selectedQuantity >= itemRequiredQuantity;

        item.dataset.offerItemState = itemIsUnlocked ? 'unlocked' : 'locked';

        item.querySelectorAll('[data-offer-lock]').forEach((lock) => {
          lock.hidden = itemIsUnlocked;
          lock.setAttribute('aria-hidden', String(itemIsUnlocked));
        });
      });
    }
  }

  customElements.define('product-offer-gifts', ProductOfferGifts);
})();
